import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import React from 'react';
import {
    VertModal,
    VertButton,
    Typography
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';

const RemoveParticipantModal = ({ isOpen, onClose, id, onRemove }) => {

    return (
        <VertModal
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => {
                onClose();
            }}
            className="container-modal-focal-point-manage"
            closable={false}
        >
            <Row justify={'center'}
                gutter={[16, 16]}
            >
                <Col span={24}>
                    <Row justify={'center'}>
                        <Typography.Text className='modal-remove-participant-text'>
                            Tem certeza que deseja excluir esta distribuição?
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24} className='modal-remove-participant-container-button'>
                    <Row justify={'center'} gutter={[16, 16]}>

                        <Col span={10}>
                            <VertButton
                                type="default"
                                size="default"
                                className='button-historic-redirect button-focal-point width-100'
                                onClick={() => { onClose() }}
                            >
                                Cancelar
                            </VertButton>
                        </Col>

                        <Col span={10}>
                            <VertButton
                                type="highlight"
                                size="default"
                                className='button-historic-redirect button-focal-point width-100'
                                onClick={() => onRemove(id)}
                            >
                                Excluir
                            </VertButton>
                        </Col>

                    </Row>
                </Col>

            </Row>

        </VertModal >
    );
};

export default RemoveParticipantModal;
